import {connect} from "react-redux";
import Sites from "./Sites";
import {bindActionCreators} from "redux";
import {getExistingSites} from "../../../../service/Valet/action";
import {getPendingActivity} from "../../../../service/BA/action";
import {isUserCheckInForModule} from "../../../../service/Account/action";

const mapStateToProps = (state) => ({
    existingSiteDetails:state.Valet.existingSiteDetails,
    activityByIdDetails:state.Activity.activityByIdDetails,
    userCheckInForModule:state.Dropdown.userCheckInForModule,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getExistingSites,
            getPendingActivity,
            isUserCheckInForModule
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Sites);
